module.exports = __webpack_public_path__ + "img/login.edc3024e.jpg";